export default __webpack_public_path__ + "static/media/payment-method-mobile.97432ffe.svg";